RivalIQ.module('export.views', function (views, App, Backbone, Marionette, $, _, s) {
    'use strict';

    views.ExportModal = Marionette.LayoutView.extend({
        template: '#exportModalTemplate',

        ui: {
            modal: '.modal'
        },

        regions: {
            modalContent: '.x-action-content',
            countWarning: '.x-company-count-warning'
        },

        modelEvents: {
            'save:succeeded': 'closeModal'
        },

        templateHelpers: function () {
            const me = this;

            return {
                s: s,
                action: me.model.action,
                title: me.model.getTitle()
            };
        },

        onBeforeShow: function () {
            const me = this;

            me.showCompanyCountWarning();
            me.showAction();
        },

        closeModal: function () {
            const me = this;
            me.ui.modal.modal('hide');
        },

        showCompanyCountWarning: function () {
            const me = this;

            if (me.getOption('warning')) {
                me.countWarning.show(new views.CompanyCountWarning({
                    model: new Backbone.Model(me.getOption('warning'))
                }));
            }
        },

        showAction: function () {
            const me = this;
            let View = null;

            const type = RivalIQ.export.type;
            const action = me.model.action;

            switch (action) {
                case type.EMAIL:
                    View = views.Email;
                    break;
                default:
                    throw new Error(`unknown action ${action}`);
            }

            me.modalContent.show(new View({
                model: me.model
            }));
        }
    });

}, window.s);
